import carPlug from "../../assets/images/PNG/car_with_plug.png";
import flash from "../../assets/images/PNG/flash.png";
import battery from "../../assets/images/PNG/car_with_battery.png";

function Feature() {
  return (
    <section className="feature position-relative">
      <div className="container">
        <div className="feature-inner p-7 rounded2 bg-white">
          <div className="row gx-md-0 gy-5">

            <div className="col-lg-4 col-md-6">
              <div className="feature-box1 pe-7">
                <img src={carPlug} alt="" className="icon-filter" />
                <h5>Fast DC Charging</h5>
                <p>High-speed charging solutions that bypass onboard conversion to deliver direct current, powering your journey in minutes rather than hours.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="feature-box2 px-7  border-start border-end">
                <img src={flash} alt="" className="icon-filter" />
                <h5>Save More Energy</h5>
                <p>Intelligent power management systems designed to optimize energy consumption and significantly reduce operational costs.</p>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="feature-box3 ps-7">
                <img src={battery} alt="" className="icon-filter" />
                <h5>Battery Friendly</h5>
                <p>Advanced thermal monitoring and adaptive charging algorithms that preserve long-term battery health and maximize life cycles.</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default Feature;
